import React from 'react'
import LoadingSpinner from 'reusableComponents/LoadingSpinner'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { breakpoints } from 'globalStyles'

const StyledContainer = styled.div`
  .body {
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 10%;
    padding-bottom: 5%;
    height: 100%;
    justify-self: center;
  }

  @media screen and ${breakpoints.tablet} {
    .body {
      padding-left: 19%;
      padding-right: 19%;
      padding-top: 10%;
      padding-bottom: 5%;
      height: 100%;
    }
  }

  @media screen and ${breakpoints.desktop} {
    .body {
      padding-left: 28%;
      padding-right: 28%;
      padding-top: 10%;
      padding-bottom: 5%;
      height: 100%;
    }
  }
`

const StyledSubContainer = styled.div`
  text-align: center;
  margin-top: 84px;
  margin-bottom: 84px;
  width: 186px;
  height: 112px;

  @media ${breakpoints.tablet} {
    margin-top: 114px;
    margin-bottom: 60px;
    height: 132px;
  }

  @media ${breakpoints.desktop} {
    margin-top: 76px;
    margin-bottom: 60px;
    height: 132px;
  }
`

const RecipientInfoSpinner = ({ loadingText }) => {
  return (
    <StyledContainer>
      <div className="body">
        <StyledSubContainer>
          <LoadingSpinner />
          <div className="loadingText">{loadingText}</div>
        </StyledSubContainer>
      </div>
    </StyledContainer>
  )
}

RecipientInfoSpinner.propTypes = {
  loadingText: PropTypes.string.isRequired,
}

export default RecipientInfoSpinner
